
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Wait, WaitEntre } from '@/__env/ext';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        @Prop()
        public Publicacion: Publicacion;

        public Preguntas: Pregunta[] = [];
        public Cargando: boolean = false;

        async mounted()
        {
            this.Preguntas.clear();
            this.Cargando = true;
            await WaitEntre( 100, 150 );
            let e = await Pregunta.find( { usuario: this.Controlador.seleccionada.Usuario.Id } );
            if ( e.Items.hasRows() )
            {
                this.Preguntas = e.Items;
            }
            this.Cargando = false;
        }
    }
